'use strict';

angular.module('docketbook')
.controller('groupSettingsFilingController', function($scope, docketService, Restangular, $window, $state, $stateParams, accessControl, Upload, $q, uuid) {
  mixpanel.track("Opened GroupSettings-Filing Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.mode = 'list';

  $scope.listLoading = false;
  $scope.selected = [];
  $scope.importSelected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'fileCode'
  };
  $scope.listCount = 0;

  $scope.goTo = function(href) {
    $window.location.href = href;
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************/
  /**** List Controls *****/
  /************************/

  $scope.loadFilingList = function() {
    $scope.promise = $q(function(resolve, reject) {
      // Get templates from docketService
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      docketService.getFileCodes(queryParams, function(fileCodes) {
        $scope.allFileCodes = fileCodes;
        if ( queryParams.offset <= 0 && fileCodes.length < queryParams.limit ) {
          $scope.listCount = fileCodes.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function(error) {
        $scope.allFileCodes = [];
        reject('Error');
      });
    });
  }

  $scope.loadFilingList();

  /*******************************/
  /***** File Code Functions *****/
  /*******************************/

  $scope.newFileCode = function() {
    $scope.fileCodeEdit = {};
    $("#fileCodeModal").fadeIn(100);
  }

  $scope.editFileCode = function(fileCode) {
    $("#fileCodeModal").fadeIn(100);
    $scope.fileCodeEdit = fileCode;
  }

  $scope.saveFileCodeAddAnother = function(fileCode) {
    // saveFileCode
    fileCode.loading = true;
    docketService.saveFileCode(fileCode, function() {
      fileCode.loading = false;
      $scope.fileCodeEdit = {};
    }, function(err) {
      fileCode.loading = false;
      $scope.alertService.presentAutoAlert('saveFileCode', err);
    });
  }

  $scope.saveFileCode = function(fileCode) {
    fileCode.loading = true;
    docketService.saveFileCode(fileCode, function() {
      fileCode.loading = false;
      $scope.closeFileCodeModal();
      $scope.loadFilingList();
    }, function(err) {
      fileCode.loading = false;
      $scope.alertService.presentAutoAlert('saveFileCode', err);
    });
  }

  $scope.deleteSelectedFileCodes = function() {
    var count = $scope.selected.length;
    swal({
			title: "Are you sure?",
			text: count + " file codes will be deleted.",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
        docketService.deleteBulkFileCodes($scope.selected, function(failures) {
          if ( failures && failures.length > 0 ) {
            $scope.alertService.presentAutoAlert('deleteBulkFileCodes', {status:202, requestName: 'Delete bulk file codes - failures ' + failures.length + ' of ' + $scope.selected.length});
            $scope.loadFilingList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkFileCodes',{status:200});
            $scope.loadFilingList();
          }
        });
			}
		});
  }

  /***************************/
  /**** UI Functionality *****/
  /***************************/

  $scope.closeFileCodeModal = function() {
    $("#fileCodeModal").fadeOut(100);
  }

  /**** Import Functionality ****/
  $scope.openImportModal = function() {
    $("#importModal").fadeIn(100);
    $scope.mode = 'import';
    $scope.fileCodeImport = { 'loading':false };
  }

  $scope.cancelImport = function() {
    $scope.closeImportModal();
    $scope.mode = 'list';
    $scope.importList = [];
  }

  $scope.closeImportModal = function() {
    $("#importModal").fadeOut(100);
  }

  $scope.importFileCodesFromFile = function(fileToUpload) {
    $scope.fileCodeImport.loading = true;

    Upload.upload({
      url: '/v1/parse',
      data: {file: fileToUpload},
      withCredentials: true
    }).then(function(resp) {
      $scope.parseFileCodesForImport(resp.data);
    }, function(resp) {
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  }

  $scope.parseFileCodesForImport = function(importData) {
    var fileCodesList = [];
    $scope.importSelected = [];

    for ( var i = 0; i < importData.length; i++ ) {
      for ( var j = 0; j < importData[i].data.length; j++ ) {
        var newFileCode = {};
        newFileCode.fileCode = String(importData[i].data[j][0]);
        newFileCode.fileName = String(importData[i].data[j][1]);
        newFileCode.costCode = String(importData[i].data[j][2]);
        newFileCode.systemCodes = importData[i].data[j][3];

        if ( newFileCode.fileCode != '' && newFileCode.fileCode != null ) {
          var matchedFileCode = $scope.findExistingFileCode(newFileCode.fileCode);
          if ( matchedFileCode ) {
            newFileCode.status = 'Update';
            newFileCode.uniqueIdentifier = matchedFileCode.uniqueIdentifier;
          } else {
            newFileCode.status = 'New';
          }
        } else {
          newFileCode.error = true;
          newFileCode.status = 'New';
        }

        $scope.validateFileCodeItem(newFileCode);
        newFileCode.importId = uuid.v4();
        $scope.importSelected.push(newFileCode);
        fileCodesList.push(newFileCode);
      }
    }
    $scope.importList = fileCodesList;
    $scope.closeImportModal();
    $scope.fileCodeImport.loading = false;
  }

  $scope.findExistingFileCode = function(fileCode) {
    if ( fileCode == null || fileCode == '' ) {
      return null;
    }

    for ( var i = 0; i < $scope.allFileCodes.length; i++ ) {
      if ( $scope.allFileCodes[i].fileCode == fileCode ) {
        // found a fileCode with the fileCode as given - exists
        return $scope.allFileCodes[i];
      }
    }

    return null;
  }

  $scope.bulkImportFileCodes = function() {
    var importList = $scope.importSelected;
    var filecodesSave = [];
    for ( var i = 0; i < importList.length; i++ ) {
      if ( importList[i].selected ) {
        var fileCode = {};
        fileCode.fileCode = importList[i].fileCode;
        fileCode.fileName = importList[i].fileName;
        fileCode.costCode = importList[i].costCode;
        fileCode.organisation = $scope.currentOrg.id;
        fileCode.organisationGroup = $scope.currentOrgGroup.id;
        if ( importList[i].uniqueIdentifier ) {
          fileCode.uniqueIdentifier = importList[i].uniqueIdentifier;
        }
        //TODO: system codes

        filecodesSave.push(fileCode);
      }
    }

    docketService.importFileCodes(filecodesSave, function(resp) {
      var codesCreated = resp.codes;
      var codeExceptions = resp.exceptions;
      $scope.mode = 'list';
      $scope.loadFilingList();
      var text = codesCreated.length + " file codes were successfully imported."
      $scope.alertService.presentAlert("success", "Import Complete!", text);
      $scope.importList = [];
    }, function(err) {
      $scope.alertService.presentAutoAlert('importFileCodes', err);
    });
  }

  $scope.validateFileCodeItem = function(fileCode) {
    var error = false;
    if ( fileCode.fileCode == null || fileCode.fileCode == '' ) {
      error = true;
    }

    if ( fileCode.fileName == null || fileCode.fileName == '' ) {
      error = true;
    }

    if ( fileCode.costCode == null || fileCode.costCode == '' ) {
      error = true;
    }

    if ( error ) {
      fileCode.error = error;
      fileCode.selected = false;
    } else {
      fileCode.error = false;
      fileCode.selected = true;
    }

  }

  $scope.removeCodeFromImportList = function(fileCode, importList) {
    var index = importList.indexOf(fileCode);
    if ( index != -1 ) {
      importList.splice(index, 1);
    }
  }

  $scope.toggleRowItem = function(item) {
    if ( item.selected ) {
      item.selected = false;
    } else {
      item.selected = true;
    }
  }

});



// WEBPACK FOOTER //
// ./src/controllers/groupSettings/filing.js